import styled from "styled-components";

export default styled.div`
  margin-top: 20px;
  display: none;
  @media screen and (max-width: 769px) {
    display: flex;
    align-items: center;
    flex-direction: column;

    .or {
      color: ${(props) => props.theme.colors.ellipse_28};
      text-align: center;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
      margin-bottom: 20px;
    }
    #roket-icon {
      cursor: pointer;
      ${({ isOpen }) => isOpen && `margin-bottom: -40px;`}
      z-index: 1;
      width: fit-content;
      height: 120px;
      #background-path {
        fill: ${(props) => props.theme.colors.ellipse_27};
      }
    }
    .content {
      width: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      position: relative;
      min-height: 600px;
      padding: 40px;
      padding-top: 80px;
      border-radius: 3rem;
      background: ${(props) => props.theme.colors.ellipse_26};
      .title {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 10px;
        > div {
          display: flex;
          flex-direction: column;
          gap: 5px;
          h3 {
            font-style: normal;
            font-weight: 600;
            font-size: 19px;
            letter-spacing: 0.045em;
            text-transform: uppercase;
            color: ${(props) => props.theme.colors.ellipse_28};
          }
          span {
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            letter-spacing: 0.135em;
            text-transform: uppercase;
            color: ${(props) => props.theme.colors.ellipse_29};
          }
        }
        .amount {
          color: ${(props) => props.theme.colors.ellipse_29};
          font-size: 32px;
          font-weight: 600;
        }
      }
      .card-custom-body {
        width: 100%;
        flex: 1;
      }
      .card-custom-footer {
        width: 100%;
      }
      .nft-collections {
        min-height: 270px;
      }
      .selected-nft-info-text {
        margin: 20px 0;
      }
      ${({ seletedNFT }) =>
        seletedNFT &&
        `
            #paint0_linear_1061_5189 {
              stop {
                :first-child {
                  stop-color: #20B5DB;
                }
                :last-child {
                  stop-color: #2597D4;
                }
              }
            }
            #the-roket {
              transform: rotate(45.16deg) translateY(-145px) translateX(-5px);
            }
            #background-path {
              fill: #2597D4 !important;
            }
      `}
    }
  }
`;
